import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export interface LTLCustomerStaff {
  email: string;
  tmsIntegrationId: number;
  ownerName: string;
  ownerId: number;
}

/** Returned with staff when the pricing integration resolves trading-partner profiles (e.g. Mohawk / 3G). */
export interface LTLTradingPartnerCompatibilityProfile {
  profileType: string;
  profileName: string;
  profileId: number;
  id: number;
}

type GetLTLCustomerStaffResponse = {
  customerList: LTLCustomerStaff[];
  compatibilityProfiles?: LTLTradingPartnerCompatibilityProfile[];
};

type GetLTLCustomerStaffOptions = {
  tmsIntegrationId?: number;
  pricingIntegrationId?: number;
  integrationName?: string;
  externalId?: string;
};

export async function getLTLCustomerStaff(
  name: string,
  externalTMSID: string,
  options: GetLTLCustomerStaffOptions = {}
): Promise<Result<GetLTLCustomerStaffResponse, ApiError>> {
  try {
    const body: {
      name: string;
      externalTMSID: string;
      tmsIntegrationId?: number;
      pricingIntegrationId?: number;
      integrationName?: string;
      externalId?: string;
    } = { name, externalTMSID };

    if (options.tmsIntegrationId != null) {
      body.tmsIntegrationId = options.tmsIntegrationId;
    }

    if (options.pricingIntegrationId != null) {
      body.pricingIntegrationId = options.pricingIntegrationId;
    }

    if (options.integrationName) {
      body.integrationName = options.integrationName;
    }

    if (options.externalId != null && options.externalId !== '') {
      body.externalId = options.externalId;
    }

    const response = await axios.post<GetLTLCustomerStaffResponse>(
      `/quote/ltl/customers/staff/select`,
      body
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLTLCustomerStaff' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get customer staff' });
    }

    return err({
      message: error.response?.data.message || 'Failed to get customer staff',
    });
  }
}
